import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectDeal} from 'api/deals';
import {loadLeadDeal as load, submitLeadDeal as submit} from 'flows/lead/deal/index';

import Spinner from 'components/Spinner';
import DealSummary from 'components/DealSummary';

export class LeadDealContainer extends React.Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
  }
  componentDidMount() {
    const invite = {id: this.props.params.inviteId};
    const deal = {id: this.props.params.dealId};
    this.props.load({invite, deal});
  }
  next() {
    this.props.submit({id: this.props.params.dealId});
  }
  render() {
    const {data, loaded} = this.props.deal || {};

    if (loaded) {
      return (
        <DealSummary next={this.next} deal={data} nextButtonText="Syndicate Deal" />
      );
    }
    return (
      <Spinner />
    );
  }
}

LeadDealContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  deal: PropTypes.object,
  params: PropTypes.object.isRequired,
};

export const mapStore = (store, ownProps) => ({
  deal: selectDeal(store, ownProps.params.dealId),
});

export default connect(mapStore, {load, submit})(LeadDealContainer);



// WEBPACK FOOTER //
// ./web/flows/lead/deal/index.js